import React from 'react';
import Logo from '../images/ftb_is_logo_trp.png';
import insta from '../images/instagram1.png';
import linkedin from '../images/linkedin.png';
import twitter from '../images/twitter.png';

export default function ContactFooter() {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="ftb-footer" style={{ padding: '60px 0 0' }}>
            <div className="container">
                <div className="row g-5 pb-5">

                    {/* Column 1 — Brand */}
                    <div className="col-md-4">
                        <img src={Logo} alt="FTB Innosphere" style={{ height: '50px', marginBottom: '16px' }} />
                        <p className="ftb-footer-title">FTB Innosphere</p>
                        <p style={{ color: 'var(--ftb-text-muted)', fontSize: '0.95rem', lineHeight: 1.7 }}>
                            Innovative IT Solutions &amp; Support. Helping businesses worldwide
                            resolve issues and deliver technology-driven results.
                        </p>
                        <div className="d-flex gap-3 mt-3">
                            <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                                <img src={linkedin} width="24" alt="LinkedIn" style={{ filter: 'brightness(0.8) grayscale(1)' }} />
                            </a>
                            <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
                                <img src={twitter} width="24" alt="Twitter" style={{ filter: 'brightness(0.8) grayscale(1)' }} />
                            </a>
                            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
                                <img src={insta} width="24" alt="Instagram" style={{ filter: 'brightness(0.8) grayscale(1)' }} />
                            </a>
                        </div>
                    </div>

                    {/* Column 2 — Quick Links */}
                    <div className="col-md-2">
                        <p className="ftb-footer-title">Quick Links</p>
                        <ul className="list-unstyled" style={{ lineHeight: 2.2 }}>
                            <li><a href="/landing">Home</a></li>
                            <li><a href="/service">Services</a></li>
                            <li><a href="/career">Careers</a></li>
                            <li><a href="/contact">Contact</a></li>
                        </ul>
                    </div>

                    {/* Column 3 — Services */}
                    <div className="col-md-2">
                        <p className="ftb-footer-title">Services</p>
                        <ul className="list-unstyled" style={{ lineHeight: 2.2 }}>
                            <li><a href="/dataAnalytics">Data Analytics</a></li>
                            <li><a href="/cloud">Cloud Computing</a></li>
                            <li><a href="/web">Web Development</a></li>
                        </ul>
                    </div>

                    {/* Column 4 — Contact */}
                    <div className="col-md-4">
                        <p className="ftb-footer-title">Contact Us</p>
                        <address style={{ fontStyle: 'normal', color: 'var(--ftb-text-muted)', fontSize: '0.95rem', lineHeight: 1.8 }}>
                            Office No. 3, S No. 846, <br />
                            Near Marathwada College, <br />
                            Shivajinagar, Maharashtra, India - 411 004.<br />
                        </address>
                        <p style={{ color: 'var(--ftb-text-muted)', fontSize: '0.95rem', marginTop: '8px' }}>
                            <a href="mailto:admin@ftbinnosphere.com">admin@ftbinnosphere.com</a>
                        </p>
                    </div>


                </div>
            </div>

            {/* Bottom bar */}
            <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', padding: '20px 0' }}>
                <div className="container d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <p style={{ color: 'var(--ftb-text-muted)', fontSize: '0.88rem', margin: 0 }}>
                        © {currentYear} FTB Innosphere. All rights reserved.
                    </p>
                    <div className="d-flex gap-4" style={{ fontSize: '0.88rem' }}>
                        <a href="/policy" style={{ color: 'var(--ftb-text-muted)' }}>Privacy Policy</a>
                        <a href="/terms" style={{ color: 'var(--ftb-text-muted)' }}>Terms &amp; Conditions</a>
                    </div>

                </div>
            </div>
        </footer>
    );
}
